import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import DOMPurify from "dompurify";

const MyNiceModal = NiceModal.create(() => {
  const modal = useModal();

  const howToUse = modal.args?.howToUse;

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"howToUse-modal"}
    >
      <div className="howToUse-modal-wrapper">
        <h2 className="howToUse-modal-title">Anwendungstipps</h2>
        <div className="howToUse-modal-content">
          {howToUse.map((e, index) => (
            <div className="element" key={index}>
              <div>
                <p className="copy" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(e)}} />
                <span className="number">{index + 1}</span>
              </div>
              {index !== howToUse.length - 1 && <div className="line"></div>}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
});

export default MyNiceModal;
